import {Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {ActionDeeplink, ActionOpenLinkToRoute} from 'src/api/types'
import {tagToUrl} from 'src/shared/utils'

import {classes} from '../support-button/SupportButton.classes'

type Props = {
  action: ActionOpenLinkToRoute | ActionDeeplink
}

function transformDeeplink(deeplink: ActionDeeplink['deeplink'] = '') {
  return `https://yandex.go.link/${deeplink.replace('yandextaxi://', '')}${
    deeplink.includes('?') ? '&' : '?'
  }adj_t=1gs0hspf_1gqtke3u`
}

export function UniversalLink({action}: Props): React.ReactElement {
  return (
    <>
      <a
        className={classes.action}
        href={'url' in action ? action.url : transformDeeplink(action.deeplink)}
        onClick={console.log}
        rel="noreferrer"
        style={{backgroundImage: action.image_tag && `url("${tagToUrl(action.image_tag)}")`}}
        target="_blank"
      />
      <Typography color="minor" justifyContent="center" variant="caption1">
        {action.title}
      </Typography>
      {'badge_text' in action && action.badge_text && (
        <Typography className={classes.badge} color="invert" group="loose" thickness="medium" variant="caption1">
          {action.badge_text}
        </Typography>
      )}
    </>
  )
}
